import { hasJsonApiErrorMatching, type JsonApiError } from 'teacher-ui-client/errors/json-api-errors'

export const TrialTeacherError = {
  title: 'Unprocessable Entity',
  code: 'trial_teacher',
  status: 422,
  detail: "teachers multiple teacher classes can't have a teacher with a trial subscription",
} as const satisfies JsonApiError

const isTrialTeacherError = (
  maybeTrialTeacherError: JsonApiError,
): maybeTrialTeacherError is typeof TrialTeacherError =>
  Boolean(
    String(maybeTrialTeacherError.status) === String(TrialTeacherError.status) &&
    (maybeTrialTeacherError.detail === TrialTeacherError.detail ||
      maybeTrialTeacherError.code === TrialTeacherError.code),
  )

export const hasTrialTeacherError = (errorPayload: unknown) =>
  hasJsonApiErrorMatching(errorPayload, isTrialTeacherError)
